export default __webpack_public_path__ + "static/media/2930 knife block C top.12462b77.png";